import { apiFetchWithRetry } from '@/lib/apiFetch';
import type { OfferingSearchResult } from '@/services/offeringSearchService';

/** How the rail was produced (ADR-102). EMPTY → the rail hides itself. */
export type RecommendationStrategy = 'PERSONALIZED' | 'POPULAR_FALLBACK' | 'EMPTY';

/** Why an offering was recommended — the strongest source that surfaced it. */
export type RecSource = 'GOAL_MATCH' | 'SAVED_TEACHER' | 'INQUIRY_AFFINITY' | 'FRESH' | 'POPULAR';

export interface RecommendationItem {
  offering: OfferingSearchResult;
  recSource: RecSource;
  recReason: string;
}

export interface RecommendationsResponse {
  strategy: RecommendationStrategy;
  generatedAt: string;
  items: RecommendationItem[];
}

/**
 * GET /api/v1/recommendations — the authenticated student "Recommended for you"
 * rail. Terminal: no filters, no pagination. Server owns candidate generation,
 * scoring, and capping; the client renders items as-is.
 */
export async function fetchRecommendations(
  accessToken: string,
  opts: { size?: number } = {},
): Promise<RecommendationsResponse> {
  const qs = new URLSearchParams();
  if (opts.size != null) qs.set('size', String(opts.size));
  const query = qs.toString();
  const res = await apiFetchWithRetry(`/api/v1/recommendations${query ? `?${query}` : ''}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!res.ok) throw new Error(`Recommendations request failed: ${res.status}`);
  return res.json();
}
